var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.normalized)?_c('div',{staticClass:"dx-alert",class:{ 'dx-alert--compact': _vm.compact },domProps:{"innerHTML":_vm._s(_vm.formattedHtml)}}):_c('span',{staticClass:"text-muted"},[_vm._v("—")])
}
var staticRenderFns = []

export { render, staticRenderFns }